import type { FaireProductEntity } from "../../entity_types/product";

export const p_hvwf9bhpcz: FaireProductEntity = {
  token: "p_hvwf9bhpcz",
  type: "product",
  name: "Handmade Sourdough Pretzels, Salted - 2.75 oz Bags",
  brandToken: "b_34xfsouq90",
  brandName: "Martins Handmade Pretzels",
  imageUrl:
    "https://cdn.faire.com/fastly/3e35e5ea38518caf1dcd8a193079e1ba5969497963b1c907eec6e79db18f3a78.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ac3f5f63a93903e703fb4799809eb84c5d0cb2b2b7d2553dbe1e9a3b3fd278fd.png",
    "https://cdn.faire.com/fastly/7bad4b8b18254f3cd5cd3c70ff9acbfc6cfc8e6b03c73b01ebb281c3e163f431.png",
    "https://cdn.faire.com/fastly/7bf9ee7832b352b8e8e9fa3aa13d8d72489fc160bd767b8c3bfda45b69afa973.jpeg",
    "https://cdn.faire.com/fastly/bc90ffd0d3d315d5e66b9566ded3e2e6b069ea7d79e574610c3e8eed22d23ce1.png",
    "https://cdn.faire.com/fastly/c93d9531d6551d000a22563526a40e4fc15b7385c2bf3dd637f8485f86e7bf48.png",
    "https://cdn.faire.com/fastly/fcb1152c2292658d9faa6ecd10823b3ac64ae27e35a9570810a2adf1675d6c81.png",
    "https://cdn.faire.com/fastly/ecbdf3738501ebf48a6fb4d949dd99e2afa013e4e3fc13d26a888c97642b7509.png",
    "https://cdn.faire.com/fastly/f0e03f730e813f542dff90acc6887f58c3a599d9a3721db5cbd70e631d4563a5.png",
    "https://cdn.faire.com/fastly/d143d1194a6f7b97210e5f346988355110603acd3a52aa5ae8d589ac9c3d9861.png",
    "https://cdn.faire.com/fastly/13d90b2c0f12c51ed4e0b317816b55feecb24c73b2668339cb0e5cbefcc8ca73.png",
    "https://cdn.faire.com/fastly/b68abcbf3e209a7c596bb6cc72599b124b44eeaabefff9cbaae2900c4583e577.png",
  ],
  priceDollars: 1.55,
  description:
    "Each pretzel starts with our simple—and secret—sourdough recipe made of flour, water, yeast, and salt. Our skilled bakers then hand-roll and hand-twist every pretzel, creating a unique, artisanal snack with a satisfying crunch and classic flavor.\n\nKey Features:\n1) Pure & Simple Ingredients: No fat, no sugar, and no preservatives—just wholesome sourdough goodness.\n2) Long Shelf Life: A 180-day shelf life is printed on every bag, ensuring product freshness for customers.\n3) Thoughtful Shipping: Special padding protects your order during transit, and free samples are included with every shipment.\n4) Timeless Quality: Handmade with care, delivering the authentic taste and texture of a true sourdough pretzel.\n\nStock Martin’s Handmade Hearth-Baked Pretzels to offer your customers a piece of history and an unparalleled snacking experience!",
  tags: [],
  msrpDollars: 2.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:16.638Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
